import { Grid } from "@mui/material";
import { HoldingDetails } from "./tables/holdingDetails";


export default function BondsHoldingDetails(): JSX.Element {
    return (
        <Grid container>
            <Grid item sm={12} sx={{ width: '100%' }}>
                <HoldingDetails
                />
            </Grid>
        </Grid>
    )
}